"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ForecastStatus = void 0;
var ForecastStatus;
(function (ForecastStatus) {
    ForecastStatus[ForecastStatus["DRAFT"] = 0] = "DRAFT";
    ForecastStatus[ForecastStatus["ACTIVE"] = 1] = "ACTIVE";
    ForecastStatus[ForecastStatus["DISABLED_BY_USER"] = 2] = "DISABLED_BY_USER";
    ForecastStatus[ForecastStatus["DISABLED_BY_SYSTEM"] = 3] = "DISABLED_BY_SYSTEM";
})(ForecastStatus || (exports.ForecastStatus = ForecastStatus = {}));
